export const PRODUCT_CATEGORIES = Object.freeze({
  PHYSICAL: "physical",
  SERVICE: "service",
  DIGITAL: "digital",
});

export const PRODUCT_SUBTYPES = Object.freeze({
  IN_PERSON: "in_person",
  ONLINE: "online",
  IMAGE_PACK: "image_pack",
  VIDEO: "video",
  PDF: "pdf",
});

export const MODERATION_STATUSES = Object.freeze({
  DRAFT: "draft",
  PENDING: "pending",
  APPROVED: "approved",
  REJECTED: "rejected",
});

export const LISTING_STATUSES = Object.freeze({
  DRAFT: "draft",
  ACTIVE: "active",
  PAUSED: "paused",
  ARCHIVED: "archived",
});

export const PRODUCT_STATUS_LABELS = Object.freeze({
  [MODERATION_STATUSES.DRAFT]: "Moderation draft",
  [MODERATION_STATUSES.PENDING]: "Pending review",
  [MODERATION_STATUSES.APPROVED]: "Approved",
  [MODERATION_STATUSES.REJECTED]: "Rejected",
  [LISTING_STATUSES.DRAFT]: "Draft",
  [LISTING_STATUSES.ACTIVE]: "Active",
  [LISTING_STATUSES.PAUSED]: "Paused",
  [LISTING_STATUSES.ARCHIVED]: "Archived",
});

export const PRODUCT_STATUS_TONE = Object.freeze({
  [MODERATION_STATUSES.DRAFT]: "neutral",
  [MODERATION_STATUSES.PENDING]: "warning",
  [MODERATION_STATUSES.APPROVED]: "success",
  [MODERATION_STATUSES.REJECTED]: "danger",
  [LISTING_STATUSES.DRAFT]: "neutral",
  [LISTING_STATUSES.ACTIVE]: "success",
  [LISTING_STATUSES.PAUSED]: "warning",
  [LISTING_STATUSES.ARCHIVED]: "muted",
});

export const CATEGORY_LABELS = Object.freeze({
  [PRODUCT_CATEGORIES.PHYSICAL]: "Physical",
  [PRODUCT_CATEGORIES.SERVICE]: "Service",
  [PRODUCT_CATEGORIES.DIGITAL]: "Digital",
});

export const SUBTYPE_LABELS = Object.freeze({
  [PRODUCT_SUBTYPES.IN_PERSON]: "In person",
  [PRODUCT_SUBTYPES.ONLINE]: "Online",
  [PRODUCT_SUBTYPES.IMAGE_PACK]: "Image pack",
  [PRODUCT_SUBTYPES.VIDEO]: "Video",
  [PRODUCT_SUBTYPES.PDF]: "PDF",
});
